import React from "react";
import { useRole } from "@/context/RoleContext";
import UserDashboard from "@/pages/dashboard/UserDashboard";
import Consultor from "@/pages/dashboard/Consultor";
import Creador from "@/pages/dashboard/Creador";
import AdminDashboard from "@/pages/dashboard/AdminDashboard";
import DirectorDashboard from "@/pages/dashboard/DirectorDashboard";
import AcademyProgress from "@/pages/dashboard/AcademyProgress";
import SupportDashboard from "@/pages/dashboard/SupportDashboard";

const DashboardRouter = () => {
  const { role } = useRole();
  switch (role) {
    case "estudiante": return <AcademyProgress />;
    case "consultor": return <Consultor />;
    case "creador": return <Creador />;
    case "admin": return <AdminDashboard />;
    case "superadmin": return <DirectorDashboard />;
    case "soporte": return <SupportDashboard />;
    default: return <UserDashboard />;
  }
};
export default DashboardRouter;
